import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HeartIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 16C9.04487 16.0004 8.59922 15.8671 8.21609 15.616C7.12913 14.9018 5.0387 13.436 3.27043 11.6462C1.10043 9.44799 0 7.37776 0 5.49154C0 4.18087 0.37913 2.97998 1.09652 2.01909C1.77681 1.10542 2.73779 0.452027 3.82509 0.163865C4.91238 -0.124296 6.06287 -0.0304962 7.09174 0.430197C8.01261 0.83642 8.83391 1.52131 9.5 2.4302C10.1661 1.51909 10.9874 0.834198 11.9083 0.430197C12.9371 -0.0304962 14.0876 -0.124296 15.1749 0.163865C16.2622 0.452027 17.2232 1.10542 17.9035 2.01909C18.6209 2.97998 19 4.18087 19 5.49154C19 7.37776 17.8996 9.4471 15.7296 11.6444C13.9613 13.4342 11.8717 14.9 10.7839 15.6142C10.401 15.866 9.9553 15.9999 9.5 16ZM5.07217 1.11375C4.72829 1.11344 4.38588 1.15977 4.05391 1.25153C3.22071 1.48536 2.48539 1.99178 1.96043 2.69331C1.38913 3.45865 1.08696 4.42665 1.08696 5.49332C1.08696 7.07199 2.0787 8.87643 4.03522 10.8569C5.73087 12.5751 7.7513 13.9902 8.80348 14.6791C9.01123 14.8148 9.25261 14.8869 9.49913 14.8869C9.74565 14.8869 9.98703 14.8148 10.1948 14.6791C11.247 13.9884 13.2657 12.5733 14.963 10.8569C16.9196 8.87643 17.9113 7.07199 17.9113 5.49332C17.9113 4.42665 17.6091 3.46042 17.0378 2.69331C16.5129 1.99178 15.7776 1.48536 14.9443 1.25153C13.4587 0.839087 11.3713 1.2702 9.96696 3.71731C9.91908 3.80094 9.85063 3.8703 9.76841 3.9185C9.68618 3.96671 9.59305 3.99207 9.49826 3.99207C9.40347 3.99207 9.31034 3.96671 9.22811 3.9185C9.14589 3.8703 9.07744 3.80094 9.02956 3.71731C7.92609 1.79109 6.39739 1.11375 5.07217 1.11375Z"
        fill="currentColor"
      />
    </svg>
  )
})

HeartIcon.displayName = 'HeartIcon'
